import { cva } from '@/styled-system/css';

export const paginationEllipsisStyles = cva({
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'Pagination.PageButton.width',
    height: 'Pagination.PageButton.height',
    color: 'Pagination.PageButton.label.default',
    textStyle: 'body-bold',
    userSelect: 'none',
  },
});
